<template>
    <v-container>
        <v-file-input
                label="Upload Files"
                prepend-icon="mdi-upload"
                multiple
                v-model="filesToUpload"
                @change="uploadFiles"
        ></v-file-input>

        <v-list>
            <v-list-item
                    v-for="(file, index) in files"
                    :key="file.name"
                    class="file-item"
            >
                <div style="width: 100px; height: 80px; display: flex; align-items: center; justify-content: center;">
                    <v-img v-if="isImage(file)">
                        <v-img :src="file.preview" max-width="100" max-height="80"></v-img>
                    </v-img>
                </div>
                <v-list-item-content>
                    <v-list-item-title>{{ file.name }}</v-list-item-title>
                </v-list-item-content>

                <v-list-item-action class="d-flex align-center" style="flex-direction: row; gap: 8px;">
                    <v-icon size="28" color="primary" @click="downloadFile(file)">mdi-download</v-icon>
                    <v-icon size="28" color="red" @click="removeFile(index)">mdi-delete</v-icon>
                </v-list-item-action>

            </v-list-item>
        </v-list>
    </v-container>
</template>

<script>
    import offerApi from "@/api/offer";
    export default {
        props: {
            offerId: {
                type: Number,
            },
        },
        data() {
            return {
                filesToUpload: [],
                files: [],
                initialFiles: [],
                filesToDelete: []
            };
        },
        watch: {
            async offerId(id) {
                this.initialFiles =  await offerApi.getFiles(id);
                this.files = [...this.initialFiles];
            }
        },
        methods: {
            uploadFiles() {
                this.filesToUpload.forEach((file) => {
                    const extFile = this.files.find(f => f.name === file.name);
                    if (extFile) return;
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.files.push({
                            name: file.name,
                            preview: e.target.result,
                        });
                    };
                    reader.readAsDataURL(file);
                });
                this.filesToUpload = [];
            },
            removeFile(index) {
                const fileToDelete = this.files.find((file, ind) => ind === index);
                if (fileToDelete && fileToDelete['name']) {
                    this.filesToDelete.push(fileToDelete['name']);
                }
                this.files.splice(index, 1);
            },
            isImage(file) {
                return file.name.match(/\.(jpeg|jpg|gif|png)$/);
            },
            async send() {
                const filesToUploadNames = this.files.map(file => file.name);
                this.filesToDelete = this.filesToDelete.filter(
                    fileName => !filesToUploadNames.includes(fileName)
                );

                for (const file of this.files) {
                    try {
                        const response = await offerApi.uploadFiles(this.offerId, file.name, file.preview, this.filesToDelete);

                        if (response.success) {
                            console.log("success");
                        } else {
                            console.error("error:", response.message);
                        }
                    } catch (error) {
                        console.error("error", error);
                    }
                }

                if (this.filesToDelete.length) {
                    await offerApi.deleteFiles(this.offerId, this.filesToDelete);
                }
            },
            downloadFile(file) {
                if (file.preview) {
                    const link = document.createElement('a');
                    link.href = file.preview;
                    link.download = file.name;
                    link.target = '_blank';
                    link.click();
                } else {
                    console.warn("No preview URL available for download");
                }
            }
        }
    };
</script>

<style scoped>
    .file-item {
        display: flex;
        align-items: center;
        margin-bottom: 2% !important;
    }
</style>
